$(function () {
    if ($('#OverviewForm').length > 0) {

        $(document).ready(function () {
            var id = jsViewOption;

            if (id == "1") {
                $(".searchtxt").removeClass('d-none');
                $(".firstnametxt").addClass('d-none'); 
                $(".lastnametxt").addClass('d-none');
                $(".emailtxt").addClass('d-none');
                $(".searchchildtxt").addClass('d-none');
                $(".searchparenttxt").addClass('d-none');
            }

            if (id == "2") {
                $(".searchtxt").addClass('d-none');
                $(".searchchildtxt").addClass('d-none');
                $(".searchparenttxt").addClass('d-none');
                $(".firstnametxt").removeClass('d-none');
                $(".lastnametxt").removeClass('d-none');
                $(".emailtxt").removeClass('d-none');
            }
        });

        $(document).keypress(
            function (event) {
                if (event.which == '13') {
                    $('.btnSearch').trigger('click');
                }
            });

        $(".radOperator").on('click', function () {
            $(".searchtxt").removeClass('d-none');
            $(".firstnametxt").addClass('d-none');
            $(".lastnametxt").addClass('d-none');
            $(".emailtxt").addClass('d-none');
            $(".searchchildtxt").addClass('d-none');
            $(".searchparenttxt").addClass('d-none');
            //$(".btnSave").removeClass('d-none');
            //$(".btnSearch").addClass('d-none');
            $(".searcherror").addClass('d-none');

        });

        $(".radEducator").on('click', function () {
            $(".searchtxt").addClass('d-none');
            $(".searchchildtxt").addClass('d-none');
            $(".searchparenttxt").addClass('d-none');
            $(".firstnametxt").removeClass('d-none');
            $(".lastnametxt").removeClass('d-none');
            $(".emailtxt").removeClass('d-none');
            //$(".btnSave").removeClass('d-none');
            //$(".btnSearch").addClass('d-none');
            $(".searcherror").addClass('d-none');

        });

        $(".radChild").on('click', function () {
            $(".searchchildtxt").removeClass('d-none');
            $(".searchparenttxt").addClass('d-none');
            $(".firstnametxt").addClass('d-none');
            $(".lastnametxt").addClass('d-none');
            $(".emailtxt").addClass('d-none');
            $(".searchtxt").addClass('d-none');
            //$(".btnSave").addClass('d-none');
            //$(".btnSearch").removeClass('d-none');
            $(".searcherror").addClass('d-none');
            $(".searchvalue").val("");

        });

        $(".radParent").on('click', function () {
            $(".searchparenttxt").removeClass('d-none');
            $(".searchchildtxt").addClass('d-none');
            $(".firstnametxt").addClass('d-none');
            $(".lastnametxt").addClass('d-none');
            $(".emailtxt").addClass('d-none');
            $(".searchtxt").addClass('d-none');
            //$(".btnSave").addClass('d-none');
            //$(".btnSearch").removeClass('d-none');
            $(".searcherror").addClass('d-none');
            $(".searchparentvalue").val("");

        });

        $(".btnSearch").on('click', function () {

                var id = $('input[type="radio"]:checked').val();
                var txt = $(".searchvalue").val();
                var parentxt = $(".searchparentvalue").val();
                var lang = jslang;
                var txtopertaor = $(".operatorsearchvalue").val();
                var txtfirstname = $(".firstname").val();
                var txtlastname = $(".lastname").val();
                var txtemail = $(".emailvalue").val();
                var baseURLop = jsbaseURLop;

                var baseURLpp = jsbaseURLapp;

                if (id == jsOptionThree) {
                if (txt != "") {

                    var searchString = txt;
                    searchString = searchString.replace('%20', '+');

                    var printURL = baseURLpp + '/' + lang + '/Admin/StudentSearch/?searchString=' + searchString;

                    if (printURL != '') {
                        window.open(printURL, "_blank");
                    }
                }
                else {
                    $(".searcherror").removeClass('d-none');
                }
            }

            if (id == jsOptionFour) {
                if (parentxt != "") {
                    var searchString = parentxt;
                    searchString = searchString.replace('%20', '+');


                    var printURL = baseURLpp + '/' + lang + '/Admin/User/?searchString=' + searchString;

                    if (printURL != '') {
                        window.open(printURL, "_blank");
                    }                }
                else {
                    $(".searcherror").removeClass('d-none');
                }
            }

            if (id == jsOptionOne) {
                if (txtopertaor != "") {

                    var searchString = txtopertaor;

                    var printURL = baseURLop + '/' + lang + '/Admin/Home/Index/?searchString=' + searchString + '&showInactive=false';

                    location.href = printURL
                }
                else {
                    $(".searcherror").removeClass('d-none');
                }
            }

            if (id == jsOptionTwo) {
                    var firstname = txtfirstname;
                    var lastname = txtlastname


                var printURL = baseURLop + '/' + lang + '/Admin/Employee/Index/?FirstNameSearch=' + txtfirstname + '&LastNameSearch=' + txtlastname + '&EmailSearch=' + txtemail;

                    location.href = printURL
            }

        });



        //$(".btnSave").on('click', function () {

        //    var id = $('input[type="radio"]:checked').val();


        //    var lang = jslang;



        //});

        $("#btnEdixt").on('click', function () {

            var lang = jslang;

            var baseURLpp = jsbaseURLapp;

            var printURL = baseURLpp + '/' + lang + '/Admin/Dashboard/';


            if (printURL != '') {
                window.open(printURL, "_blank");
            }
        });


        $("#btnFeedback").on('click', function () {;

            var baseURLpp = jsFeedbackURL;

            var printURL = baseURLpp;


            if (printURL != '') {
                window.open(printURL, "_blank");
            }
        });


    }
}); 